"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnOutsideClick = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
// useOnOutsideClick aka useOnClickOutside
function useOnOutsideClick(rootRef, callback, enabled, checkOutsideFn) {
    if (enabled === void 0) { enabled = true; }
    (0, react_1.useEffect)(function () {
        if (!enabled) {
            return;
        }
        var checkOutsideClick = function (e) {
            var target = e.target;
            var roots = (Array.isArray(rootRef)
                ? (0, flatMap_1.default)(rootRef, function (ref) {
                    if (typeof ref === 'string') {
                        var elements = document.querySelectorAll(ref);
                        return Array.from(elements);
                    }
                    return ref.current;
                })
                : [rootRef.current]).filter(function (node) { return !!node; });
            if (roots.length === 0) {
                return;
            }
            if (
            // any of the roots contains our target
            roots.some(function (root) { return root.contains(target); }) ||
                // or it has ignore-enforcing ancestors
                target.closest('.ignore-react-onclickoutside') ||
                // or the custom checking method says the element is inside
                (checkOutsideFn && !checkOutsideFn(target, e))) {
                // this was an inside click, nothing to see here
            }
            else {
                callback(e);
            }
        };
        document.addEventListener('mousedown', checkOutsideClick);
        document.addEventListener('touchstart', checkOutsideClick);
        return function () {
            document.removeEventListener('mousedown', checkOutsideClick);
            document.removeEventListener('touchstart', checkOutsideClick);
        };
    }, [callback, rootRef, enabled, checkOutsideFn]);
}
exports.useOnOutsideClick = useOnOutsideClick;
//# sourceMappingURL=useOnOutsideClick.js.map